import resolver from './resolver';
import interfaces from './interfaces';

export default {
  resolver,
  interfaces
};